
















import { Component, Prop, Watch } from 'vue-property-decorator';
import { WxBaseWidget } from '../wxBaseWidget';
import { WxRequest as request } from '../../../lib/request';

@Component({ name: 'wxAutocompleteWidget' })
export default class WxAutocompleteWidget extends WxBaseWidget {
    private static arrayUnique(array: any[]) {
        const a = array.concat();
        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j]) {
                    a.splice(j--, 1);
                }
            }
        }

        return a;
    }

    @Prop(Boolean) private readonly show!: boolean;
    @Prop(Array) private readonly items?: any[];
    @Prop(String) private readonly itemText?: string;
    @Prop(String) private readonly itemValue?: string;

    private lookupItems?: any[] = [];

    private dataLoading = false;

    @Watch('show', { immediate: true })
    private onShowChanged(val: boolean) {
        if (val) {
            this.$emit('parent-shown');
        }
    }

    public get value() {
        if (this.isLookup) {
            const value: any = {};
            value[this.computedItemValue] = this.item[this.fieldName];
            value[this.computedItemText] = this.item[this.fieldDesc.options.detail.resolvedFieldName];
            return value;
        } else {
            return this.item[this.fieldName];
        }
    }

    public set value(value: any) {
        if (value) {
            if (this.isLookup) {
                this.item[this.fieldName] = value[this.computedItemValue];
                this.item[this.fieldDesc.options.detail.resolvedFieldName] = value[this.computedItemText];
            } else {
                this.item[this.fieldName] = value;
            }
            this.$emit('input', value);
        }
    }

    public get resolvedItems() {
        return this.isLookup && this.item[this.fieldName]
            ? [{ KEY: String(this.item[this.fieldName]), VALUE: String(this.item[this.fieldDesc.options.detail.resolvedFieldName]) }]
            : undefined;
    }

    public get computedItems() {
        let computedItems;
        if (this.items && this.items.length > 0) {
            computedItems = this.items;
        } else if (this.lookupItems && this.lookupItems.length > 0) {
            if (this.resolvedItems && this.resolvedItems.length > 0) {
                computedItems = WxAutocompleteWidget.arrayUnique(this.resolvedItems.concat(this.lookupItems));
            } else {
                computedItems = this.lookupItems;
            }
        } else {
            computedItems = this.resolvedItems;
        }
        return computedItems;
    }

    public get computedItemText(): string {
        return this.itemText || 'VALUE';
    }

    public get computedItemValue(): string {
        return this.itemValue || 'KEY';
    }

    public get isLookup(): boolean {
        return !!this.fieldDesc.options && !!this.fieldDesc.options.detail;
    }

    private async lookupDetail() {
        if ((!this.items || this.items.length === 0) && this.isLookup) {
            this.dataLoading = true;
            const res = await request().execute(this.fieldDesc.options.detail.lookup);
            this.dataLoading = false;
            if (this.lookupItems) this.lookupItems = res.data;
        }
    }
}
